var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isModal)?_c('section',{staticClass:"base-modal wh100 fixed left0 top0 z999999 flex-center",on:{"click":_vm.close}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }